var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_infb", class: _vm._class, attrs: { role: "alert" } },
    [
      _vm.tone == "warning"
        ? [
            _c("svg", { attrs: { viewBox: "0 0 28 25" } }, [
              _c("path", {
                attrs: {
                  fill: "#ffc107",
                  d: "M1.5 24.8a1.5 1.5 0 01-1.3-2.2L12.7.9a1.5 1.5 0 012.6 0l12.5 21.7a1.5 1.5 0 01-1.3 2.2z",
                },
              }),
              _c("path", {
                attrs: { fill: "#000", d: "M12.9 17.4L12.5 8h3l-.4 9.4h-2.3z" },
              }),
              _c("circle", {
                attrs: { fill: "#000", cx: "14", cy: "20.6", r: "1.5" },
              }),
            ]),
          ]
        : _vm.tone == "ok"
        ? [
            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
              _c("path", {
                attrs: { d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z" },
              }),
              _c("path", {
                attrs: {
                  d: "M18.707 9.707l-7.56 7.56a1 1 0 01-1.414 0L6.28 13.814A1 1 0 017.694 12.4l2.746 2.746 6.853-6.853a1 1 0 111.414 1.414z",
                  fill: "#fff",
                },
              }),
            ]),
          ]
        : _vm.tone == "error"
        ? [
            _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
              _c("path", {
                attrs: { d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z" },
              }),
              _c("path", {
                attrs: {
                  d: "M13.414 12l3.293 3.293a1 1 0 11-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 11-1.414-1.414L10.586 12 7.293 8.707a1 1 0 111.414-1.414L12 10.586l3.293-3.293a1 1 0 111.414 1.414z",
                  fill: "#fff",
                },
              }),
            ]),
          ]
        : [
            _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
              _c("path", {
                attrs: { d: "M10 0a10 10 0 1010 10A10 10 0 0010 0z" },
              }),
              _c("path", {
                attrs: { d: "M11 15H9V9h2zm0-8H9V5h2z", fill: "#fff" },
              }),
            ]),
          ],
      _c("div", { staticClass: "_infm" }, [_vm._t("default")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }